import styled from 'styled-components';
import good from '../../assets/images/good.png';
import line from '../../assets/images/line.svg';
import low from '../../assets/images/low.png';

const StyledContainer = styled.div`
	position: relative;
	width: 400px;
	height: 60px;
	background: #111314;
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;
`;

const StyledInnerContainer = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 360px;
	height: 20px;
	background: url(${line});
	background-repeat: no-repeat;
	background-size: 360px 20px;
	background-position: center;
`;

const StyledLowIndicator = styled.div`
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	display: flex;
	align-items: center;
	justify-content: center;
	width: 180px;
	height: 50px;
	background: url(${low});
	background-repeat: no-repeat;
	background-size: 100% 100%;
	background-position: center;
`;

const StyledGoodIndicator = styled.div`
	position: absolute;
	left: 50%;
	transform: translateX(-50%);
	width: 100px;
	height: 50px;
	background: url(${good});
	background-repeat: no-repeat;
	background-size: 100% 100%;
	background-position: center;
`;

const StyledFishingContainer = styled.div`
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 10px;

	.dot {
		width: 4px;
		height: 4px;
		border-radius: 4px;
		background-color: #ffffff;
	}

	img {
		width: 20px;
		height: 20px;
		user-select: none;
		pointer-events: none;
	}
`;

const StyledFishIconContainer = styled.div`
	position: absolute;
	top: 50%;
	left: 360px;
	z-index: 3;
	transform: translateY(-50%);
	display: flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	background: #2d70da;
	border-radius: 20px;

	img {
		width: 10px;
		height: 10px;
		user-select: none;
		pointer-events: none;
	}
`;

const StyledCatchIndicatorWrapper = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 370px;
	height: 30px;
	padding: 4px;
	border-radius: 20px;
	border: 1px solid rgba(255, 255, 255, 0.05);
`;

const StyledCatchIndicator = styled.div`
	position: relative;
	height: 20px;
	border-radius: 20px;
	transition:
		width 0.1s ease,
		background-color 0.3s ease;
	overflow: hidden;

	.dot {
		position: absolute;
		top: 50%;
		right: 7px;
		transform: translateY(-50%);
		width: 6px;
		height: 6px;
		border-radius: 6px;
		background-color: #ffffff;
	}
`;

export {
	StyledCatchIndicator,
	StyledCatchIndicatorWrapper,
	StyledContainer,
	StyledFishIconContainer,
	StyledFishingContainer,
	StyledGoodIndicator,
	StyledInnerContainer,
	StyledLowIndicator,
};
